import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";
import BatchDataStatusBanner from "../components/BatchDataStatusBanner";
import ZillowSniper from "../components/ZillowSniper";
import SavedSearchesPanel from "../components/SavedSearchesPanel";

export default function Scans() {
  const [logs, setLogs] = useState([]);
  const load = () => api.get("/scan/logs").then(r => setLogs(r.data)).catch(() => toast.error("Failed to load"));
  useEffect(() => { load(); }, []);
  return (
    <AppShell header={<div className="border-b border-zinc-800 px-6 py-4"><div className="overline">Scan Log</div><h1 className="text-lg font-semibold">Data source scan history</h1></div>}>
      <BatchDataStatusBanner showWhenHealthy />
      <div className="p-6">
        <SavedSearchesPanel onChanged={load} />
        <ZillowSniper onScanned={load} />
        <div className="border border-zinc-800 rounded-sm overflow-hidden overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm" data-testid="scan-log-table">
            <thead className="bg-[#111114]">
              <tr className="text-[10px] mono uppercase tracking-[0.2em] text-zinc-500">
                <th className="text-left px-4 py-2.5">Started</th>
                <th className="text-left px-4 py-2.5">Finished</th>
                <th className="text-right px-4 py-2.5">Results</th>
                <th className="text-right px-4 py-2.5">Inserted</th>
                <th className="text-left px-4 py-2.5">Status</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && (
                <tr><td colSpan={5} className="text-center text-zinc-500 py-10 mono text-xs">No scans yet — trigger from the dashboard.</td></tr>
              )}
              {logs.map(l => (
                <tr key={l.id} className="border-t border-zinc-800/70 hover:bg-[#111114]">
                  <td className="px-4 py-2.5 mono text-xs">{fmtDate(l.started_at)}</td>
                  <td className="px-4 py-2.5 mono text-xs">{fmtDate(l.finished_at)}</td>
                  <td className="px-4 py-2.5 mono text-right">{l.results_count}</td>
                  <td className="px-4 py-2.5 mono text-right text-emerald-400">{l.inserted_count}</td>
                  <td className="px-4 py-2.5">
                    <span className={`mono text-[10px] uppercase tracking-[0.15em] px-2 py-0.5 rounded-sm border ${l.status === "success" ? "border-emerald-500/40 text-emerald-400" : l.status === "error" ? "border-red-500/40 text-red-400" : "border-zinc-700 text-zinc-400"}`}>{l.status}</span>
                    {l.error && <div className="text-[10px] text-red-400 mono mt-1">{l.error}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}
